export enum InstanceType {
  OTHER = 'other',
  EAAS = 'eaas',
  DEV = 'dev',
  PTL = 'ptl',
  PROD = 'prod'
}
